import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Archives from "../pages/archives/page";
import ArchiveDetail from "../pages/archives/detail/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/archives", element: <Archives /> },
  { path: "/archives/:slug", element: <ArchiveDetail /> },
  { path: "/about", element: <About /> },
  { path: "*", element: <NotFound /> },
];

export default routes;